import styled from 'styled-components'

export const MarkedImageWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const MarksOverlayLayer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
`

export const MarkOverlay = styled.div<{
  x: number
  y: number
  width: number
  height: number
}>`
  position: absolute;
  left: ${({ x }) => x}%;
  top: ${({ y }) => y}%;
  width: ${({ width }) => width}%;
  height: ${({ height }) => height}%;
  border: 2px solid #05426d;
  box-sizing: border-box;
`

export const MarkBadge = styled.div`
  position: absolute;
  top: 3px;
  left: 3px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  font-size: 10px;
  padding: 1px 5px;
  border-radius: 3px;
  white-space: nowrap;
  max-width: calc(100% - 6px);
  overflow: hidden;
  text-overflow: ellipsis;
`
